export default __webpack_public_path__ + "static/media/arrowLeft.fba7cb62.svg";